// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + chunkId + "." + "0a6b3c0c7610df81ca0f" + ".js";
};